import { render } from "./Tarifs_Course.vue?vue&type=template&id=e062e5ee"
import script from "./Tarifs_Course.vue?vue&type=script&lang=js"
export * from "./Tarifs_Course.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__